import { ts } from '@/plugins/i18nFormat'

const sexLimits = [null, 'male', 'female', 'mix', 'male+mix', 'female+mix']

const otherLimits = [null, 'cze', 'region', 'district']

export function allSexLimits() {
    return sexLimits.map((limit) => ({
        value: limit,
        label: ts(limit === null ? 'sexLimit-all' : 'sexLimit-' + limit),
    }))
}

export function allOtherLimits() {
    return otherLimits.map((limit) => ({
        value: limit,
        label: ts(limit === null ? 'otherLimit-all' : 'otherLimit-' + limit),
    }))
}
